export var privateNumber = function privateNumber(centralApi) {
  return {
    post: function post(data) {
      return centralApi.post('/private-number', data);
    },
    delete: function _delete(id, data) {
      return centralApi.delete("/private-number/".concat(id), {
        params: data
      });
    },
    index: function index(filters) {
      return centralApi.get('/private-number', {
        params: filters
      });
    }
  };
};